import React, {createElement} from 'react'
import moduleCss from './index.module.scss'
import { TYPE_Chip, useChip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { formatChip} from "@ifeng/lowcode_tool/src/method/chip";
import Chip from 'Chip'

export interface Nav_1_props {
    nodeId?: string
    style: object

    navChip: TYPE_Chip

    mainWidth: number
    height: number
    backgroundColor: string
    isSticky: boolean

    isHasLeftImage: boolean
    leftImageUrl: string
    leftImageWidth: number
    leftImageHeight: number
    leftImageStyle: object

    titleStyle: object

    subTitleStyle: object
    isSubTitleUnderline: boolean
    subTitleHoverColor: string

}

const Nav_1: React.FC<Nav_1_props> = (props) => {
    const {
        nodeId,
        style,
        navChip,
        mainWidth,
        height,
        backgroundColor,
        isSticky,
        isHasLeftImage,
        leftImageUrl,
        leftImageWidth,
        leftImageHeight,
        leftImageStyle,
        titleStyle,
        subTitleStyle,
        isSubTitleUnderline,
        subTitleHoverColor
    } = props

    const navChipData = useChip(navChip)
    const navChipComponentData = formatChip(navChip)

    return (
        <Chip {...navChipComponentData}>
            <div id={nodeId} className={`${moduleCss.nav1} ${isSticky ? moduleCss.sticky : ''}`} style={{height, backgroundColor, ...style}}>
                <div className={moduleCss.navContent} style={{width: `${mainWidth}px`}}>
                    <div>
                        {
                            isHasLeftImage &&
                            <img
                                src={leftImageUrl}
                                style={{
                                    width: leftImageWidth,
                                    height: leftImageHeight,
                                    ...leftImageStyle
                                }}
                                alt=""
                            />
                        }
                    </div>
                    <div className={moduleCss.navs}>
                        {
                            navChipData.map((item, index) => {
                                const splitNum = Math.ceil(item.subTitle.length / 2)
                                const top = item.subTitle.slice(0, splitNum)
                                const bottom = item.subTitle.slice(splitNum)

                                return (
                                    <div className={moduleCss.navItem} key={index}>
                                        <div className={moduleCss.mainTitle} style={titleStyle}>{item.title}</div>
                                        <div className={moduleCss.sub}>
                                            <div className={moduleCss.subTitle}>
                                                {
                                                    top.map((sub, idx) => {
                                                        return (
                                                            <a
                                                                href={sub.url}
                                                                target="_blank"
                                                                key={`${index}_top_${idx}`}
                                                                rel="noreferrer"
                                                                className={ isSubTitleUnderline ? moduleCss.underline : '' }
                                                                // @ts-ignore
                                                                style={{ '--hover-color': subTitleHoverColor, ...subTitleStyle }}
                                                            >
                                                                {sub.name}
                                                            </a>
                                                        )
                                                    })
                                                }
                                            </div>
                                            <div className={moduleCss.subTitle}>
                                                {
                                                    bottom.map((sub, idx) => {
                                                        return (
                                                            <a
                                                                key={`${index}_bottom_${idx}`}
                                                                href={sub.url}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className={ isSubTitleUnderline ? moduleCss.underline : '' }
                                                                // @ts-ignore
                                                                style={{ '--hover-color': subTitleHoverColor, ...subTitleStyle }}
                                                            >
                                                                {sub.name}
                                                            </a>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
                <Mask visible={!navChip.id} zIndex={3}>
                    示例结构化碎片：{navChip.default.id}
                </Mask>
            </div>
        </Chip>
    )
}

export default Nav_1
